<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisField from 'dashboard/components-next/LaisField.vue';

defineProps({
  witnesses: { type: Array, required: true },
  errors: { type: Object, default: () => ({}) },
  disabled: { type: Boolean, default: false },
});
const emit = defineEmits(['update']);
const { t } = useI18n();
</script>

<template>
  <LaisCard
    :title="t('SALES.DELIVERY.WITNESSES.TITLE')"
    prefix-icon="i-lucide-users-round"
  >
    <div class="grid gap-4 md:grid-cols-2">
      <div
        v-for="(witness, index) in witnesses"
        :key="index"
        class="grid gap-3"
      >
        <span
          class="text-xs font-bold uppercase tracking-wide text-lais-text-muted"
        >
          {{ t('SALES.DELIVERY.WITNESSES.ITEM', { index: index + 1 }) }}
        </span>
        <LaisField
          :label="t('SALES.DELIVERY.WITNESSES.NAME')"
          :error="errors[`witness_${index}_name`]"
          required
        >
          <input
            :value="witness.name"
            class="h-10 w-full rounded-lais-sm border border-lais-border bg-white px-3 text-sm"
            :disabled="disabled"
            @input="emit('update', index, 'name', $event.target.value)"
          />
        </LaisField>
        <LaisField
          :label="t('SALES.DELIVERY.WITNESSES.EMAIL')"
          :error="errors[`witness_${index}_email`]"
          required
        >
          <input
            :value="witness.email"
            type="email"
            class="h-10 w-full rounded-lais-sm border border-lais-border bg-white px-3 text-sm"
            :disabled="disabled"
            @input="emit('update', index, 'email', $event.target.value)"
          />
        </LaisField>
      </div>
    </div>
  </LaisCard>
</template>
